import(/* webpackMode: "eager" */ "/app/app/[locale]/(layout)/(home)/error.tsx");
